module.exports = __webpack_public_path__ + "img/Peru.c73122b9.svg";